<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title">
            {{ activeLanguageTranslations?.bibliographyLabel  | translate }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
      <!--Panjabi Bibliography-->
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography1 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography2 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography3 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography4 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography5 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography6 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography7 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography8 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography9 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography10 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography11 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography12 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography13 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography14 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography15 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography16 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography17 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography18 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography19 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography20 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography21 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography22 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography23 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography24 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography25 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography26 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography27 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography28 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography29 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography30 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography31 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography32 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography33 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography34 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography35 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography36 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography37 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography38 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography39 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography40 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography41 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography42 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography43 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography44 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography45 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography46 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography47 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography48 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography49 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography50 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography51 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography52 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography53 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography54 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography55 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography56 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography57 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography58 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography59 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography60 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography61 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography62 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography63 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography64 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography65 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography66 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography67 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography68 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography69 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography70 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography71 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography72 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography73 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography74 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography75 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography76 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography77 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography78 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography79 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography80 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography81 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography82 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography83 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography84 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography85 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography86 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography87 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography88 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography89 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography90 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography91 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography91 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography92 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography93 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography94 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography95 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography96 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography97 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography98 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography99 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography100 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography101 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography102 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography103 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography104 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography105 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography106 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography107 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography108 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography109 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography110 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography111 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography112 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography113 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography114 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography115 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography116 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography117 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography118 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography119 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography120 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography121 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography122 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography123 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography124 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography125 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography126 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography127 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography128 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography129 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography130 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography131 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography132 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography133 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography134 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography135 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography136 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography137 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography138 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography139 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography140 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography141 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography142 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography143 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography144 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography145 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography146 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography147 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography148 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography149 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography150 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography151 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography152 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography153 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography154 }}
        </div>

        <!-- <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography155 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography156 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography157 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography158 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography159 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography160 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography161 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography162 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography163 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography164 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography165 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography166 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography167 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography168 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography169 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography170 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography171 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography172 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography173 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography174 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography175 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography176 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography177 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography178 }}
        </div> -->
        <div class="static-content-paragraph" class="sectionDivider"></div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography179 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography180 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography181 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography182 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsPA?.bibliography183 }}
        </div>
      <!--English Bibliography-->
       <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography1 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography2 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography3 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography4 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography5 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography6 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography7 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography8 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography9 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography10 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography11 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography12 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography13 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography14 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography15 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography16 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography17 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography18 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography19 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography20 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography21 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography22 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography23 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography24 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography25 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography26 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography27 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography28 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography29 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography30 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography31 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography32 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography33 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography34 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography35 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography36 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography37 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography38 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography39 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography40 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography41 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography42 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography43 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography44 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography45 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography46 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography47 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography48 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography49 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography50 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography51 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography52 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography53 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography54 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography55 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography56 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography57 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography58 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography59 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography60 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography61 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography62 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography63 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography64 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography65 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography66 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography67 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography68 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography69 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography70 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography71 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography72 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography73 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography74 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography75 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography76 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography77 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography78 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography79 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography80 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography81 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography82 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography83 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography84 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography85 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography86 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography87 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography88 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography89 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography90 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography91 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography91 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography92 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography93 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography94 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography95 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography96 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography97 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography98 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography99 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography100 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography101 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography102 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography103 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography104 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography105 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography106 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography107 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography108 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography109 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography110 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography111 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography112 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography113 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography114 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography115 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography116 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography117 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography118 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography119 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography120 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography121 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography122 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography123 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography124 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography125 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography126 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography127 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography128 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography129 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography130 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography131 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography132 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography133 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography134 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography135 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography136 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography137 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography138 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography139 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography140 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography141 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography142 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography143 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography144 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography145 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography146 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography147 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography148 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography149 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography150 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography151 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography152 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography153 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography154 }}
        </div>

        <!-- <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography155 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography156 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography157 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography158 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography159 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography160 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography161 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography162 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography163 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography164 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography165 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography166 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography167 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography168 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography169 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography170 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography171 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography172 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography173 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography174 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography175 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography176 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography177 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslationsEN?.bibliography178 }}
        </div> -->
      </div>
        <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
